import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { PriceCalculatorComponent } from './components/price-calculator/price-calculator.component';
import { providePriceCalculator } from '@helsana/price-calculator';
import { provideWebComponent } from './utils/webcomponents';
import {
  PricedProductTeaserListWrapperComponent
} from './components/priced-product-teaser-list-wrapper/priced-product-teaser-list-wrapper.component';

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2020 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

if (environment.production) {
  enableProdMode();
}

provideWebComponent('aem-priced-product-teaser-list-app', 'priced-product-teaser-list', PriceCalculatorComponent, PricedProductTeaserListWrapperComponent, providePriceCalculator);
